import React from 'react'
import RightSideModal, {
  RightSideModalProps,
} from '@/checkout-instore-legacy/components/Commons/RightSideModal'
import { InstallmentsContent } from './InstallmentsContent'
import { Installment } from '@/checkout-instore-legacy/product/typings'

type Props = {
  installments: Installment[]
  sellingPriceCents: number
} & RightSideModalProps

export const InstallmentsRightSideModal = ({
  installments,
  sellingPriceCents,
  ...props
}: Props) => (
  <RightSideModal {...props} data-testid="installments-right-side-modal">
    <InstallmentsContent
      installments={installments}
      sellingPriceCents={sellingPriceCents}
    />
  </RightSideModal>
)
